import {XIcon} from '@primer/octicons-react'
import {IconButton, Popover} from '@primer/react'

import styles from './InboxOptionsTip.module.css'

interface InboxOptionsTipProps {
  onDismiss: () => void
}

export function InboxOptionsTip({onDismiss}: InboxOptionsTipProps) {
  return (
    <Popover open caret="top-right" className={styles.InboxOptionsTip}>
      <Popover.Content className={styles.Content}>
        <div className={styles.Header}>
          <p className={styles.Title}>Customize your view</p>
          <IconButton
            icon={XIcon}
            aria-label="Dismiss tip"
            variant="invisible"
            size="small"
            onClick={onDismiss}
            className={styles.CloseButton}
          />
        </div>
        <p className={styles.Message}>
          Tailor your Inbox to fit your workflow, or pick a different view to open by default at github.com/pulls
        </p>
      </Popover.Content>
    </Popover>
  )
}
